import {ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {DatevAuthStatusService} from './services/datev-auth-status.service';

export const datevGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): MaybeAsync<GuardResult> => {
    const datevAuth = inject(DatevAuthStatusService);
    const router = inject(Router);

    if (!datevAuth.getAuthStatus()()) {
        // UrlTree statt datevAuth.loginDatev() (window.open-Hardredirect): der Guard trifft
        // nur die Routing-Entscheidung, die Startseite bietet den DATEV-Login-Button selbst an
        // - analog zu authGuard, der bei fehlender Auth ebenfalls per UrlTree umleitet statt
        // selbst Seiteneffekte auszuloesen.
        return router.createUrlTree(['']);
    }
    return true;
};
